export default "__VITE_ASSET__Dd_uuv5f__"